<button mat-raised-button color="primary" class="col-12" bsDatepicker [bsConfig]="bsConfig"
        (bsValueChange)="setDate($event)" [disabled]="disabled" placement={{placement}}>
  <span *ngIf="selectedDate != null">{{selectedDate | date: format}} <fa-icon [icon]="faCalendar"></fa-icon></span>
  <span *ngIf="selectedDate == null">Indefinite</span>
</button>
